<template>
  <b-container fluid class="font-jumper mt-5">
    <div v-if="!acountoKey || !billingoKey" class="border rounded-lg p-4 mb-5">
      <h5 class="">Számlázó bekötés</h5>
      <div class="my-3 font-poppins">Kérlek, válaszd ki a számlázó programodat, használd a kulcsot, és indulhat az
        összekötés!
      </div>
      <div class="row">
        <div class="col-12 col-md-6">
          <b-form-select
              v-model="selectedInvoicing"
              :options="invoicingOptions"
          ></b-form-select>
        </div>
      </div>
    </div>

    <div v-if="selectedInvoicing === 'szamlazzhu' || acountoKey" class="border rounded-lg p-4 mb-5">
      <h5 class="mb-3">Acounto kulcs</h5>
      <div class="row">
        <div class="col-6">
          <b-form-input
              class="profile-input-field mb-2"
              type="text"
              v-model="acountoKey"
              trim
          ></b-form-input>
        </div>
        <div class="col-6 text-right">
          <b-button
              variant="primary"
              @click="generateSzamlazzhuKey()"
          >{{ $cte("invoice.generate") }}
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-8">
          <div class="my-3">
            <div class="font-poppinsbold">Nyomd meg a Generálás gombot, másold ki az itt kapott kulcsot, lépj be a <a
                href="https://szamlazz.hu" target="_blank">Számlázz.hu</a>
              fiókodba és illeszd be az Acounto kulcs mezőbe!
            </div>
            <div class="mt-3 font-poppins">Ha segítségre van szükséged, olvasd el kapcsolódó <a
                href="https://acounto.com/billingo-szamlazzhu/" target="_blank">blogposztunkat</a>.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedInvoicing === 'billingo' || billingoKey" class="border rounded-lg p-4 mb-5">
      <h5 class="mb-3">Billingo V3 kulcs</h5>
      <div class="row">
        <div class="col-6">
          <b-form-input
              class="profile-input-field mb-2"
              type="text"
              v-model="billingoKey"
              trim
          ></b-form-input>
        </div>
        <div class="col-6 text-right">
          <b-button
              variant="primary"
              @click="connectBillingo()"
          >Indítás
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-8">
          <div class="my-3">
            <div class="font-poppinsbold">Lépj be <a href="https://www.billingo.hu" target="_blank">Billingo</a> fiókodba, hozz létre új API
              kulcsot és másold be ide, majd nyomd meg az Indítás gombot!
            </div>
            <div class="mt-3 font-poppins">Ha segítségre van szükséged, olvasd el kapcsolódó <a
                href="https://acounto.com/billingo-szamlazzhu/" target="_blank">blogposztunkat</a>.
            </div>
          </div>
        </div>
      </div>
    </div>
  </b-container>
</template>

<script>
import Api from "api-client";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "InvoicingConnection",
  components: {},
  data() {
    return {
      billingoKey: "",
      acountoKey: "",
      szamlazzId: "",
      selectedInvoicing: null,
      isSzamlazzhuConnectionSuccess: false,
      isBillingoConnectionSuccess: false,
      isSzamlazzhuConnectionFaliure: false,
      isBillingoConnectionFaliure: false,
      isBillingoConnectionWaitingForInvoices: false,
      isSzamlazzhuConnectionWaitingForInvoices: false,
      invoicingOptions: [
        {value: null, text: this.$cte("dropdown.select")},
        {value: "billingo", text: "Billingo"},
        {value: "szamlazzhu", text: "Számlázz.hu"},
      ],
      saveButtonClicked: false,
    };
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
  created() {
    this.getSzamlazzhuKey();
    this.getBillingoUserByCompany();
  },
  methods: {
    ...mapActions("app", ["login"]),
    connectBillingo() {
      if (!this.billingoKey) {
        this.$toast.error({
          title: this.$cte("common.error"),
          message: 'Kérlek írd be a Billingo kulcsot!',
        });
        return;
      }

      Api.saveBillingoToken(this.getActiveCompany.id, this.billingoKey).then(() => {
        this.$toast.success({
          title: this.$cte("toast.success"),
          message: this.$cte("toast.invoicing-connection-success"),
        });
      });
    },
    generateSzamlazzhuKey() {
      Api.generateSzamlazzhuKey(this.getActiveCompany.id).then((resp) => {
        this.acountoKey = resp.data.key;
      });
    },
    getSzamlazzhuKey() {
      Api.getSzamlazzhuKey(this.getActiveCompany.id).then((resp) => {
        this.acountoKey = resp.data.key;
      });
    },
    getBillingoUserByCompany() {
      Api.getBillingoToken(this.getActiveCompany.id).then(resp => {
        this.billingoKey = resp.data.token;
      });
    },
  },
};
</script>

<style scoped>
.card-body {
  padding: 6px !important;
}

.no-padding {
  padding: 0% !important;
}

.bold-text {
  font-weight: 600;
}

.connection-failure {
  color: #dc3545;
}

.copy-button {
  width: max-content !important;
  border: none !important;
  background-color: #fff !important;
}

.copy-button:hover {
  color: #479f49 !important;
}

.copy-button:focus {
  box-shadow: none !important;
}
</style>
